export default __webpack_public_path__ + "static/media/bicepcurls.eb892974.png";